import {CropUtils} from './CropUtils';

export class CountryUtils {

    // language ISO_639_1
    static get LANGUAGE () {

        return {
            GERMAN: 'de',
            ENGLISH: 'en',
            FRENCH: 'fr',
            DUTCH: 'nl',
            POLISH: 'pl',
            PORTUGUESE : 'pt',
            UKRAINIAN: 'uk',
            SPANISH: 'es',
            HUNGARIAN: 'hu',
            CZECH: 'cs',
            JAPANESE: 'ja',
            RUSSIAN: 'ru',
            ITALIAN: 'it',
            LITHUANIAN: 'lt'
        };
    }

    // country ISO_3166_1_ALPHA_2
    static get COUNTRY () {

        return {
            GERMANY: 'de',
            FRANCE: 'fr',
            BRAZIL: 'br',
            AUSTRIA: 'at',
            NETHERLAND: 'nl',
            POLAND: 'pl',
            UKRAINE: 'ua',
            CANADA: 'ca',
            USA: 'us',
            ARGENTINA: 'ar',
            BELGIUM: 'be',
            GREAT_BRITAIN: 'gb',
            HUNGARY: 'hu',
            CZECH_REPUBLIC: 'cz',
            JAPAN: 'jp',
            RUSSIA: 'ru',
            ITALY: 'it',
            LITHUANIA: 'lt',
            IRELAND: 'ie'
        };
    }

    static getProvincesForCanada () {

        return [
            {label: __('CANADA.STATE.ALBERTA'), key: 'AB'},
            {label: __('CANADA.STATE.BRITISH_COLUMBIA'), key: 'BC'},
            {label: __('CANADA.STATE.MANITOBA'), key: 'MB'},
            {label: __('CANADA.STATE.NEW_BRUNSWICK'), key: 'NB'},
            {label: __('CANADA.STATE.NEWFOUNDLAND_AND_LABRADOR'), key: 'NL'},
            {label: __('CANADA.STATE.NORTHWEST_TERRITORIES'), key: 'NT'},
            {label: __('CANADA.STATE.NOVA_SCOTIA'), key: 'NS'},
            {label: __('CANADA.STATE.NUNAVUT'), key: 'NU'},
            {label: __('CANADA.STATE.ONTARIO'), key: 'ON'},
            {label: __('CANADA.STATE.PRINCE_EDWARD_ISLAND'), key: 'PE'},
            {label: __('CANADA.STATE.QUEBEC'), key: 'QC'},
            {label: __('CANADA.STATE.SASKATCHEWAN'), key: 'SK'},
            {label: __('CANADA.STATE.YUKON'), key: 'YT'}
        ];
    }

    static getProvincesForUsa () {

        return [
            {label: __('USA.STATE.ALABAMA'), key: 'AL'},
            {label: __('USA.STATE.ALASKA'), key: 'AK'},
            {label: __('USA.STATE.ARIZONA'), key: 'AZ'},
            {label: __('USA.STATE.ARKANSAS'), key: 'AR'},
            {label: __('USA.STATE.CALIFORNIA'), key: 'CA'},
            {label: __('USA.STATE.COLORADO'), key: 'CO'},
            {label: __('USA.STATE.CONNECTICUT'), key: 'CT'},
            {label: __('USA.STATE.DELAWARE'), key: 'DE'},
            {label: __('USA.STATE.FLORIDA'), key: 'FL'},
            {label: __('USA.STATE.GEORGIA'), key: 'GA'},
            {label: __('USA.STATE.HAWAII'), key: 'HI'},
            {label: __('USA.STATE.IDAHO'), key: 'ID'},
            {label: __('USA.STATE.ILLINOIS'), key: 'IL'},
            {label: __('USA.STATE.INDIANA'), key: 'IN'},
            {label: __('USA.STATE.IOWA'), key: 'IA'},
            {label: __('USA.STATE.KANSAS'), key: 'KS'},
            {label: __('USA.STATE.KENTUCKY'), key: 'KY'},
            {label: __('USA.STATE.LOUISIANA'), key: 'LA'},
            {label: __('USA.STATE.MAINE'), key: 'ME'},
            {label: __('USA.STATE.MARYLAND'), key: 'MD'},
            {label: __('USA.STATE.MASSACHUSETTS'), key: 'MA'},
            {label: __('USA.STATE.MICHIGAN'), key: 'MI'},
            {label: __('USA.STATE.MINNESOTA'), key: 'MN'},
            {label: __('USA.STATE.MISSISSIPPI'), key: 'MS'},
            {label: __('USA.STATE.MISSOURI'), key: 'MO'},
            {label: __('USA.STATE.MONTANA'), key: 'MT'},
            {label: __('USA.STATE.NEBRASKA'), key: 'NE'},
            {label: __('USA.STATE.NEVADA'), key: 'NV'},
            {label: __('USA.STATE.NEW_HAMPSHIRE'), key: 'NH'},
            {label: __('USA.STATE.NEW_JERSEY'), key: 'NJ'},
            {label: __('USA.STATE.NEW_MEXICO'), key: 'NM'},
            {label: __('USA.STATE.NEW_YORK'), key: 'NY'},
            {label: __('USA.STATE.NORTH_CAROLINA'), key: 'NC'},
            {label: __('USA.STATE.NORTH_DAKOTA'), key: 'ND'},
            {label: __('USA.STATE.OHIO'), key: 'OH'},
            {label: __('USA.STATE.OKLAHOMA'), key: 'OK'},
            {label: __('USA.STATE.OREGON'), key: 'OR'},
            {label: __('USA.STATE.PENNSYLVANIA'), key: 'PA'},
            {label: __('USA.STATE.RHODE_ISLAND'), key: 'RI'},
            {label: __('USA.STATE.SOUTH_CAROLINA'), key: 'SC'},
            {label: __('USA.STATE.SOUTH_DAKOTA'), key: 'SD'},
            {label: __('USA.STATE.TENNESSEE'), key: 'TN'},
            {label: __('USA.STATE.TEXAS'), key: 'TX'},
            {label: __('USA.STATE.UTAH'), key: 'UT'},
            {label: __('USA.STATE.VERMONT'), key: 'VT'},
            {label: __('USA.STATE.VIRGINIA'), key: 'VA'},
            {label: __('USA.STATE.WASHINGTON'), key: 'WA'},
            {label: __('USA.STATE.WEST_VIRGINIA'), key: 'WV'},
            {label: __('USA.STATE.WISCONSIN'), key: 'WI'},
            {label: __('USA.STATE.WYOMING'), key: 'WY'}
        ];
    }

    static getProvincesForBrazil () {

        return [
            {label: __('BRAZIL.STATE.ACRE'), key: 'AC'},
            {label: __('BRAZIL.STATE.ALAGOAS'), key: 'AL'},
            {label: __('BRAZIL.STATE.AMAPA'), key: 'AP'},
            {label: __('BRAZIL.STATE.AMAZONAS'), key: 'AM'},
            {label: __('BRAZIL.STATE.BAHIA'), key: 'BA'},
            {label: __('BRAZIL.STATE.CEARA'), key: 'CE'},
            {label: __('BRAZIL.STATE.DISTRITO_FEDERAL'), key: 'DF'},
            {label: __('BRAZIL.STATE.ESPIRITO_SANTO'), key: 'ES'},
            {label: __('BRAZIL.STATE.GOIAS'), key: 'GO'},
            {label: __('BRAZIL.STATE.MARANHAO'), key: 'MA'},
            {label: __('BRAZIL.STATE.MATO_GROSSO'), key: 'MT'},
            {label: __('BRAZIL.STATE.MATO_GROSSO_DO_SUL'), key: 'MS'},
            {label: __('BRAZIL.STATE.MINAS_GERAIS'), key: 'MG'},
            {label: __('BRAZIL.STATE.PARA'), key: 'PA'},
            {label: __('BRAZIL.STATE.PARAIBA'), key: 'PB'},
            {label: __('BRAZIL.STATE.PARANA'), key: 'PR'},
            {label: __('BRAZIL.STATE.PERNAMBUCO'), key: 'PE'},
            {label: __('BRAZIL.STATE.PIAUI'), key: 'PI'},
            {label: __('BRAZIL.STATE.RIO_DE_JANEIRO'), key: 'RJ'},
            {label: __('BRAZIL.STATE.RIO_GRANDE_DO_NORTE'), key: 'RN'},
            {label: __('BRAZIL.STATE.RIO_GRANDE_DO_SUL'), key: 'RS'},
            {label: __('BRAZIL.STATE.RONDONIA'), key: 'RO'},
            {label: __('BRAZIL.STATE.RORAIMA'), key: 'RR'},
            {label: __('BRAZIL.STATE.SANTA_CATARINA'), key: 'SC'},
            {label: __('BRAZIL.STATE.SAO_PAULO'), key: 'SP'},
            {label: __('BRAZIL.STATE.SERGIPE'), key: 'SE'},
            {label: __('BRAZIL.STATE.TOCANTINS'), key: 'TO'}
        ];
    }

    static getProvincesForGermany () {

        return [
            {label: __('GERMANY.STATE.BADEN_WURTTEMBERG'), key: 'BW'},
            {label: __('GERMANY.STATE.BAVARIA'), key: 'BY'},
            {label: __('GERMANY.STATE.BERLIN'), key: 'BE'},
            {label: __('GERMANY.STATE.BRANDENBURG'), key: 'BB'},
            {label: __('GERMANY.STATE.BREMEN'), key: 'HB'},
            {label: __('GERMANY.STATE.HAMBURG'), key: 'HH'},
            {label: __('GERMANY.STATE.HESSE'), key: 'HE'},
            {label: __('GERMANY.STATE.LOWER_SAXONY'), key: 'NI'},
            {label: __('GERMANY.STATE.MECKLENBURG_VORPOMMERN'), key: 'MV'},
            {label: __('GERMANY.STATE.NORTH_RHINE_WESTPHALIA'), key: 'NW'},
            {label: __('GERMANY.STATE.RHINELAND_PALATINE'), key: 'RP'},
            {label: __('GERMANY.STATE.SAARLAND'), key: 'SL'},
            {label: __('GERMANY.STATE.SAXONY'), key: 'SN'},
            {label: __('GERMANY.STATE.SAXONY_ANHALT'), key: 'ST'},
            {label: __('GERMANY.STATE.SCHLESWIG_HOLSTEIN'), key: 'SH'},
            {label: __('GERMANY.STATE.THURINGIA'), key: 'TH'}
        ];
    }

    static getProvincesForFrance () {

        return [
            {label: __('FRANCE.STATE.AUVERGNE_RHONE_ALPES'), key: 'ARA'},
            {label: __('FRANCE.STATE.BOURGOGNE_FRANCHE_COMTE'), key: 'BFC'},
            {label: __('FRANCE.STATE.BRETAGNE'), key: 'BRE'},
            {label: __('FRANCE.STATE.CENTRE_VAL_DE_LOIRE'), key: 'CVL'},
            {label: __('FRANCE.STATE.CORSE'), key: 'COR'},
            {label: __('FRANCE.STATE.GRAND_EST'), key: 'GES'},
            {label: __('FRANCE.STATE.GUADELOUPE'), key: 'GUA'},
            {label: __('FRANCE.STATE.HAUTS_DE_FRANCE'), key: 'HDF'},
            {label: __('FRANCE.STATE.ILE_DE_FRANCE'), key: 'IDF'},
            {label: __('FRANCE.STATE.LA_REUNION'), key: 'LRE'},
            {label: __('FRANCE.STATE.MAYOTTE'), key: 'MAY'},
            {label: __('FRANCE.STATE.NORMANDIE'), key: 'NOR'},
            {label: __('FRANCE.STATE.NOUVELLE_AQUITAINE'), key: 'NAQ'},
            {label: __('FRANCE.STATE.OCCITANIE'), key: 'OCC'},
            {label: __('FRANCE.STATE.PAYS_DE_LA_LOIRE'), key: 'PDL'},
            {label: __('FRANCE.STATE.PROVENCE_ALPES_COTE_DAZUR'), key: 'PAC'}
        ];
    }

    static getProvincesForAustria () {

        return [
            {label: __('AUSTRIA.STATE.BURGENLAND'), key: '1'},
            {label: __('AUSTRIA.STATE.CARINTHIA'), key: '2'},
            {label: __('AUSTRIA.STATE.LOWER_AUSTRIA'), key: '3'},
            {label: __('AUSTRIA.STATE.UPPER_AUSTRIA'), key: '4'},
            {label: __('AUSTRIA.STATE.SALZBURG'), key: '5'},
            {label: __('AUSTRIA.STATE.STYRIA'), key: '6'},
            {label: __('AUSTRIA.STATE.TYROL'), key: '7'},
            {label: __('AUSTRIA.STATE.VORARLBERG'), key: '8'},
            {label: __('AUSTRIA.STATE.VIENNA'), key: '9'}
        ];
    }

    static getProvincesForNetherlands () {

        return [
            {label: __('NETHERLANDS.STATE.DRENTHE'), key: 'DR'},
            {label: __('NETHERLANDS.STATE.FLEVOLAND'), key: 'FL'},
            {label: __('NETHERLANDS.STATE.FRIESLAND'), key: 'FR'},
            {label: __('NETHERLANDS.STATE.GELDERLAND'), key: 'GE'},
            {label: __('NETHERLANDS.STATE.GRONINGEN'), key: 'GR'},
            {label: __('NETHERLANDS.STATE.LIMBURG'), key: 'LI'},
            {label: __('NETHERLANDS.STATE.NORTH_BRABANT'), key: 'NB'},
            {label: __('NETHERLANDS.STATE.NORTH_HOLLAND'), key: 'NH'},
            {label: __('NETHERLANDS.STATE.OVERIJSSEL'), key: 'OV'},
            {label: __('NETHERLANDS.STATE.UTRECHT'), key: 'UT'},
            {label: __('NETHERLANDS.STATE.ZEELAND'), key: 'ZE'},
            {label: __('NETHERLANDS.STATE.SOUTH_HOLLAND'), key: 'ZH'}
        ];
    }

    static getProvincesForPoland () {

        return [
            {label: __('POLAND.STATE.LOWER_SILESIA'), key: '02'},
            {label: __('POLAND.STATE.KUYAVIA_POMERANIA'), key: '04'},
            {label: __('POLAND.STATE.LUBLIN'), key: '06'},
            {label: __('POLAND.STATE.LUBUSZ'), key: '08'},
            {label: __('POLAND.STATE.LODZ'), key: '10'},
            {label: __('POLAND.STATE.LESSER_POLAND'), key: '12'},
            {label: __('POLAND.STATE.MAZOVIA'), key: '14'},
            {label: __('POLAND.STATE.OPOLE'), key: '16'},
            {label: __('POLAND.STATE.SUBCARPATHIA'), key: '18'},
            {label: __('POLAND.STATE.PODLASKIE'), key: '20'},
            {label: __('POLAND.STATE.POMERANIA'), key: '22'},
            {label: __('POLAND.STATE.SILESIA'), key: '24'},
            {label: __('POLAND.STATE.HOLY_CROSS'), key: '26'},
            {label: __('POLAND.STATE.WARMIA_MASURIA'), key: '28'},
            {label: __('POLAND.STATE.GREATER_POLAND'), key: '30'},
            {label: __('POLAND.STATE.WEST_POMERANIA'), key: '32'}
        ];
    }

    static getProvincesForUkraine () {

        return [
            {label: __('UKRAINE.STATE.CHERKASKA_OBLAST'), key: '71'},
            {label: __('UKRAINE.STATE.CHERNIHIVSKA_OBLAST'), key: '74'},
            {label: __('UKRAINE.STATE.CHERNIVETSKA_OBLAST'), key: '77'},
            {label: __('UKRAINE.STATE.DNIPROPETROVSKA_OBLAST'), key: '12'},
            {label: __('UKRAINE.STATE.DONETSKA_OBLAST'), key: '14'},
            {label: __('UKRAINE.STATE.IVANO_FRANKIVSKA_OBLAST'), key: '26'},
            {label: __('UKRAINE.STATE.KHARKIVSKA_OBLAST'), key: '63'},
            {label: __('UKRAINE.STATE.KHERSONSKA_OBLAST'), key: '65'},
            {label: __('UKRAINE.STATE.KHMELNYTSKA_OBLAST'), key: '68'},
            {label: __('UKRAINE.STATE.KIROVOHRADSKA_OBLAST'), key: '35'},
            {label: __('UKRAINE.STATE.KYIVSKA_OBLAST'), key: '32'},
            {label: __('UKRAINE.STATE.LUHANSKA_OBLAST'), key: '09'},
            {label: __('UKRAINE.STATE.LVIVSKA_OBLAST'), key: '46'},
            {label: __('UKRAINE.STATE.MYKOLAIVSKA_OBLAST'), key: '48'},
            {label: __('UKRAINE.STATE.ODESKA_OBLAST'), key: '51'},
            {label: __('UKRAINE.STATE.POLTAVSKA_OBLAST'), key: '53'},
            {label: __('UKRAINE.STATE.RIVNENSKA_OBLAST'), key: '56'},
            {label: __('UKRAINE.STATE.SUMSKA_OBLAST'), key: '59'},
            {label: __('UKRAINE.STATE.TERNOPILSKA_OBLAST'), key: '61'},
            {label: __('UKRAINE.STATE.VINNYTSKA_OBLAST'), key: '05'},
            {label: __('UKRAINE.STATE.VOLYNSKA_OBLAST'), key: '07'},
            {label: __('UKRAINE.STATE.ZAKARPATSKA_OBLAST'), key: '21'},
            {label: __('UKRAINE.STATE.ZAPORIZKA_OBLAST'), key: '23'},
            {label: __('UKRAINE.STATE.ZHYTOMYRSKA_OBLAST'), key: '18'},
            {label: __('UKRAINE.STATE.AVTONOMNA_RESPUBLIKA_KRYM'), key: '43'},
            {label: __('UKRAINE.STATE.KYIV'), key: '30'},
            {label: __('UKRAINE.STATE.SEVASTOPOL'), key: '40'}
        ];
    }

    static getProvincesForArgentina () {

        return [
            {label: __('ARGENTINA.STATE.CIUDAD_AUTONOMA_LA_DE_BUENOS_AIRES'), key: 'AR-C'},
            {label: __('ARGENTINA.STATE.BUENOS_AIRES'), key: 'AR-B'},
            {label: __('ARGENTINA.STATE.CATAMARCA'), key: 'AR-K'},
            {label: __('ARGENTINA.STATE.CHACO'), key: 'AR-H'},
            {label: __('ARGENTINA.STATE.CHUBUT'), key: 'AR-U'},
            {label: __('ARGENTINA.STATE.CORDOBA'), key: 'AR-X'},
            {label: __('ARGENTINA.STATE.CORRIENTES'), key: 'AR-W'},
            {label: __('ARGENTINA.STATE.ENTRE_RIOS'), key: 'AR-E'},
            {label: __('ARGENTINA.STATE.FORMOSA'), key: 'AR-P'},
            {label: __('ARGENTINA.STATE.JUJUY'), key: 'AR-Y'},
            {label: __('ARGENTINA.STATE.LA_PAMPA'), key: 'AR-L'},
            {label: __('ARGENTINA.STATE.LA_RIOJA'), key: 'AR-F'},
            {label: __('ARGENTINA.STATE.MENDOZA'), key: 'AR-M'},
            {label: __('ARGENTINA.STATE.MISIONES'), key: 'AR-N'},
            {label: __('ARGENTINA.STATE.NEUQUEN'), key: 'AR-Q'},
            {label: __('ARGENTINA.STATE.RIO_NEGRO'), key: 'AR-R'},
            {label: __('ARGENTINA.STATE.SALTA'), key: 'AR-A'},
            {label: __('ARGENTINA.STATE.SAN_JUAN'), key: 'AR-J'},
            {label: __('ARGENTINA.STATE.SAN_LUIS'), key: 'AR-D'},
            {label: __('ARGENTINA.STATE.SANTA_CRUZ'), key: 'AR-Z'},
            {label: __('ARGENTINA.STATE.SANTA_FE'), key: 'AR-S'},
            {label: __('ARGENTINA.STATE.SANTIAGO_DEL_ESTERO'), key: 'AR-G'},
            {label: __('ARGENTINA.STATE.TIERRA_DEL_FUEGO'), key: 'AR-V'},
            {label: __('ARGENTINA.STATE.TUCUMAN'), key: 'AR-T'}
        ];
    }

    static getProvincesByCountry (country) {

        switch (country) {
            case CountryUtils.COUNTRY.CANADA:
                return CountryUtils.getProvincesForCanada();
            case CountryUtils.COUNTRY.USA:
                return CountryUtils.getProvincesForUsa();
            case CountryUtils.COUNTRY.BRAZIL:
                return CountryUtils.getProvincesForBrazil();
            case CountryUtils.COUNTRY.GERMANY:
                return CountryUtils.getProvincesForGermany();
            case CountryUtils.COUNTRY.FRANCE:
                return CountryUtils.getProvincesForFrance();
            case CountryUtils.COUNTRY.AUSTRIA:
                return CountryUtils.getProvincesForAustria();
            case CountryUtils.COUNTRY.NETHERLAND:
                return CountryUtils.getProvincesForNetherlands();
            case CountryUtils.COUNTRY.POLAND:
                return CountryUtils.getProvincesForPoland();
            case CountryUtils.COUNTRY.UKRAINE:
                return CountryUtils.getProvincesForUkraine();
            case CountryUtils.COUNTRY.ARGENTINA:
                return CountryUtils.getProvincesForArgentina();
            default: return undefined;
        }
    }

    static getSupportedCountries () {

        return [
            {countryLabel : __('CANADA'), 
                country: CountryUtils.COUNTRY.CANADA, 
                languages:[
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('GERMANY'), 
                country: CountryUtils.COUNTRY.GERMANY, 
                languages:[
                    CountryUtils.LANGUAGE.GERMAN,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('FRANCE'), 
                country: CountryUtils.COUNTRY.FRANCE, 
                languages:[
                    CountryUtils.LANGUAGE.FRENCH,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('BRAZIL'), 
                country: CountryUtils.COUNTRY.BRAZIL, 
                languages:[
                    CountryUtils.LANGUAGE.PORTUGUESE,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('AUSTRIA'), 
                country: CountryUtils.COUNTRY.AUSTRIA, 
                languages:[
                    CountryUtils.LANGUAGE.GERMAN,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('POLAND'), 
                country: CountryUtils.COUNTRY.POLAND, 
                languages:[
                    CountryUtils.LANGUAGE.POLISH,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('UKRAINE'), 
                country: CountryUtils.COUNTRY.UKRAINE, 
                languages:[
                    CountryUtils.LANGUAGE.UKRAINIAN,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('NETHERLAND'), 
                country: CountryUtils.COUNTRY.NETHERLAND, 
                languages:[
                    CountryUtils.LANGUAGE.DUTCH,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('USA'), 
                country: CountryUtils.COUNTRY.USA, 
                languages:[
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('ARGENTINA'),
                country: CountryUtils.COUNTRY.ARGENTINA,
                languages:[
                    CountryUtils.LANGUAGE.SPANISH,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('BELGIUM'),
                country: CountryUtils.COUNTRY.BELGIUM,
                languages:[
                    CountryUtils.LANGUAGE.FRENCH,
                    CountryUtils.LANGUAGE.DUTCH,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('GREAT_BRITAIN'),
                country: CountryUtils.COUNTRY.GREAT_BRITAIN,
                languages:[
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('HUNGARY'),
                country: CountryUtils.COUNTRY.HUNGARY,
                languages:[
                    CountryUtils.LANGUAGE.HUNGARIAN,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('CZECH_REPUBLIC'),
                country: CountryUtils.COUNTRY.CZECH_REPUBLIC,
                languages:[
                    CountryUtils.LANGUAGE.CZECH,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('JAPAN'),
                country: CountryUtils.COUNTRY.JAPAN,
                languages:[
                    CountryUtils.LANGUAGE.JAPANESE,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('ITALY'),
                country: CountryUtils.COUNTRY.ITALY,
                languages:[
                    CountryUtils.LANGUAGE.ITALIAN,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('LITHUANIA'),
                country: CountryUtils.COUNTRY.LITHUANIA,
                languages:[
                    CountryUtils.LANGUAGE.LITHUANIAN,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('RUSSIA'),
                country: CountryUtils.COUNTRY.RUSSIA,
                languages:[
                    CountryUtils.LANGUAGE.RUSSIAN,
                    CountryUtils.LANGUAGE.ENGLISH
                ]},
            {countryLabel : __('IRELAND'),
                country: CountryUtils.COUNTRY.IRELAND,
                languages:[
                    CountryUtils.LANGUAGE.ENGLISH
                ]}
        ];
    }

    /**
     * Get config for specific country
     *
     * @param {string} countryCode
     * @returns {object|undefined}
     */
    static getCountryConfig (countryCode) {
        if (!countryCode) {
            console.warn('countryCode expected');
            return;
        }

        return _.find(this.getSupportedCountries(), {country: countryCode.toLowerCase()});
    }

    /**
     * Check if country code is supported
     * for example "DE" - true, "AQ" - false
     *
     * @param {string} countryCode
     * @returns {boolean}
     */
    static isSupportedCountry (countryCode) {
        if (!countryCode) {
            console.warn('countryCode expected');
            return false;
        }
        return Boolean(this.getCountryConfig(countryCode));
    }

    /**
     * @param {string} country - "de"
     * @param {string} language - "en"
     * @returns {object} - {prefix: '/de/en_de', locale: 'en_de'}
     */
    static getPaths (country, language) {
        if (!country) {
            console.error('expected country');
            return;
        }

        let countryConfig = this.getCountryConfig(country);

        if (!countryConfig) {
            console.error('unknown country', country);
            return;
        }

        if (!language) {
            language = countryConfig.languages[0];
        } else {
            if (!countryConfig.languages.includes(language)) {
                console.error('unsupported language for country', language, country);
            }
        }

        return {
            prefix: `/${country}/${language}_${country}`,
            locale: `${language}_${country}`,
            country,
            language
        };
    }

    /**
     * @returns {[{object}]}
     */
    static getSupportedCountriesWithPrefixes () {
        return CountryUtils.getSupportedCountries().reduce((result, item) => {
            let languages = _.clone(item.languages);
            let nonEnglishLanguages = _.without(languages, CountryUtils.LANGUAGE.ENGLISH);

            if (nonEnglishLanguages.length > 1) { // For example Belgium has 2 official legal langs
                nonEnglishLanguages.forEach((lang) => {
                    let path =CountryUtils.getPaths(item.country, lang);

                    result.push(_.extend({}, item, {
                        pathPrefix: path.prefix,
                        countryLabel: `${item.countryLabel} - ${lang.toUpperCase()}`,
                        locale: path.locale
                    }));
                });
            } else {
                let path = CountryUtils.getPaths(item.country);

                result.push(_.extend({}, item, {
                    pathPrefix: path.prefix,
                    locale: path.locale
                }));
            }

            return result;
        }, []);
    }

    //get language code from locale
    static getLanguageCodeByUrlParam (locale) {

        locale = String(locale).toLowerCase().split('_');

        let languageCode = locale[0];
        let countryCode = locale[1];
        let config = _.find(CountryUtils.getSupportedCountries(),
            (config) => (config.country === countryCode));

        if (config && _.includes(config.languages, languageCode)) {
            return languageCode;
        }

        return CountryUtils.LANGUAGE.ENGLISH;
    }

    //get the country uuid based on country code
    static getRegistrationCountryUuid (country){

        switch (country.toLowerCase()) {

            case CountryUtils.COUNTRY.GERMANY:
                return '4d6e5015-80a7-8e0b-991e-440be462713e';
            case CountryUtils.COUNTRY.FRANCE:
                return '42c102ad-0cd5-3721-2119-4f13338974c7';
            case CountryUtils.COUNTRY.BRAZIL:
                return '0147379e-5769-1ad4-5af7-1e1caa55f53a';
            case CountryUtils.COUNTRY.AUSTRIA:
                return '5c856785-e523-bfed-f3c2-81e824bc1869';
            case CountryUtils.COUNTRY.NETHERLAND:
                return 'd9736851-bcf4-2b76-51a3-58e56e3e4a65';
            case CountryUtils.COUNTRY.POLAND:
                return 'b5fb92f3-b164-148a-7001-240724fe1444';
            case CountryUtils.COUNTRY.UKRAINE:
                return 'd8805a1a-4205-95d1-f1a9-b07fa49adae2';
            case CountryUtils.COUNTRY.CANADA:
                return '9bbc89c6-19f1-a6e3-907d-327066f1d864';
            case CountryUtils.COUNTRY.USA:
                return 'da57d265-58c6-beb7-6c56-bb49a009e160';
            case CountryUtils.COUNTRY.ARGENTINA:
                return '935d0ca6-5678-dbf5-fa2a-10fe928a106b';
            case CountryUtils.COUNTRY.BELGIUM:
                return '46c4f0f4-b97e-9619-3047-d1d410505bc5';
            case CountryUtils.COUNTRY.GREAT_BRITAIN:
                return '37c04c8e-8bb0-350e-681b-0d821d7af0a7';
            case CountryUtils.COUNTRY.HUNGARY:
                return '2657e0e6-d7fe-1b59-99a1-055a02acea19';
            case CountryUtils.COUNTRY.CZECH_REPUBLIC:
                return 'a8c7e5d2-59b5-53e4-e415-6a80d8d1ac1f';
            case CountryUtils.COUNTRY.RUSSIA:
                return '401cbf13-86bf-71ee-5c72-a0ab61d15adc';
            case CountryUtils.COUNTRY.ITALY:
                return 'e46a8e41-35d4-795f-862d-55fc2044438a';
            case CountryUtils.COUNTRY.LITHUANIA:
                return '6b98d52f-7e48-daed-7c2e-000697985794';
            case CountryUtils.COUNTRY.JAPAN:
                return '0f59ff55-c86b-4b7b-4eaa-eb003d47dcd3';
            case CountryUtils.COUNTRY.IRELAND:
                return '4717076c-797b-6fe9-4aba-286aab58cca9';
            default:
                return undefined;
        }
    }

    //get the default map provider for a country
    static getProvider (country) {

        switch (country.toLowerCase()) {
            case CountryUtils.COUNTRY.UKRAINE:
                return 'google';
            case CountryUtils.COUNTRY.HUNGARY:
                return 'google';
            case CountryUtils.COUNTRY.CZECH_REPUBLIC:
                return 'google';
            case CountryUtils.COUNTRY.JAPAN:
                return 'google';
            default:
                return 'bing';
        }
    }

    //get the default bbox for a country
    static getBBox (country) {

        switch (country.toLowerCase()) {

            case CountryUtils.COUNTRY.GERMANY:
                return [[55.05814, 15.04205], [47.27021, 5.86624]];
            case CountryUtils.COUNTRY.FRANCE:
                return [[51.089062, 9.55932], [41.33374, -5.1406]];
            case CountryUtils.COUNTRY.BRAZIL:
                return [[-33.7683777809, -73.9872354804], [5.24448639569, -34.7299934555]];
            case CountryUtils.COUNTRY.AUSTRIA:
                return [[51.06901, 20.01708], [43.64402, 9.03076]];
            case CountryUtils.COUNTRY.NETHERLAND:
                return [[53.78767, 7.97607], [50.41551, 2.48291]];
            case CountryUtils.COUNTRY.POLAND:
                return [[55.24155, 24.58740], [48.47292, 13.60107]];
            case CountryUtils.COUNTRY.UKRAINE:
                return [[55.22902, 52.88818], [42.40723, 10.70068]];
            case CountryUtils.COUNTRY.CANADA:
                return [[67.28901, -64.86328], [46.55886, -149.23828]];
            case CountryUtils.COUNTRY.USA:
                return [[47.295694, -108.582718], [32.936860, -68.131057]];
            case CountryUtils.COUNTRY.ARGENTINA:
                return [[-20.259878, -83.964761], [-46.768275, -35.141518]];
            case CountryUtils.COUNTRY.BELGIUM:
                return [[51.652961, 2.213000], [49.483292, 6.563586]];
            case CountryUtils.COUNTRY.GREAT_BRITAIN:
                return [[55.839083, -5.818006], [50.086224, 2.037218]];
            case CountryUtils.COUNTRY.HUNGARY:
                return [[48.530812, 15.621334], [45.881998, 23.146969]];
            case CountryUtils.COUNTRY.CZECH_REPUBLIC:
                return [[51.113541, 11.907955], [48.592615, 19.082027]];
            case CountryUtils.COUNTRY.RUSSIA:
                return [[78.504807, 14.796871], [36.044721, -171.597166]];
            case CountryUtils.COUNTRY.ITALY:
                return [[47.498700, 2.195556], [36.186722, 21.267822]];
            case CountryUtils.COUNTRY.LITHUANIA:
                return [[56.846052, 19.396152], [53.406349, 27.624912]];
            default:
                return [[55.05814, 15.04205], [47.27021, 5.86624]];
        }
    }

    //get the min and max limit of area(in m2) per country
    static getAreaRangeForField (country) {

        switch (country.toLowerCase()) {
            case CountryUtils.COUNTRY.FRANCE:
                return {
                    min: 200.0,
                    max: 2000000.0,
                };
            case CountryUtils.COUNTRY.GERMANY:
                return {
                    min: 200.0,
                    max: 2270120.0,
                };
            case CountryUtils.COUNTRY.UKRAINE:
                return {
                    min: 200.0,
                    max: 6077180.0,
                };
            case CountryUtils.COUNTRY.GREAT_BRITAIN:
                return {
                    min: 200.0,
                    max: 2000000.0,
                };
            case CountryUtils.COUNTRY.POLAND:
                return {
                    min: 200.0,
                    max: 2323980.0,
                };
            case CountryUtils.COUNTRY.CZECH_REPUBLIC:
                return {
                    min: 200.0,
                    max: 2151080.0,
                };
            case CountryUtils.COUNTRY.CANADA:
                return {
                    min: 200.0,
                    max: 8712820.0,
                };
            case CountryUtils.COUNTRY.USA:
                return {
                    min: 200.0,
                    max: 5108220.0,
                };
            case CountryUtils.COUNTRY.HUNGARY:
                return {
                    min: 200.0,
                    max: 2983220.0,
                };
            case CountryUtils.COUNTRY.BRAZIL:
                return {
                    min: 200.0,
                    max: 11846400.0,
                };
            case CountryUtils.COUNTRY.AUSTRIA:
                return {
                    min: 200.0,
                    max: 2000000.0,
                };
            case CountryUtils.COUNTRY.NETHERLAND:
                return {
                    min: 200.0,
                    max: 2000000.0,
                };
            case CountryUtils.COUNTRY.ARGENTINA:
                return {
                    min: 200.0,
                    max: 10592980.0,
                };
            case CountryUtils.COUNTRY.BELGIUM:
                return {
                    min: 200.0,
                    max: 2000000.0,
                };
            default:
                return {
                    min: 1000,
                    max: 10000000,
                };
        }
    }

    static getFieldMonitorValidity (country) {

        switch (country.toLowerCase()) {

            case CountryUtils.COUNTRY.BRAZIL:
                return '2020-12-01T00:00:00Z';
            case CountryUtils.COUNTRY.ARGENTINA:
                return '2021-04-30T00:00:00Z';
            case CountryUtils.COUNTRY.JAPAN:
                return '2021-12-31T00:00:00Z';
            default:
                return '2020-12-31T00:00:00Z';
        }
    }

    /**
     * @deprecated
     */
    static getSupportedFeatures (country) {

        switch (country.toLowerCase()) {

            case CountryUtils.COUNTRY.GERMANY:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE,
                        CropUtils.CROPS.POTATO,
                        CropUtils.CROPS.SUGAR_BEET,
                        CropUtils.CROPS.WINTER_RYE
                    ],
                    zoneSprayFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE,
                        CropUtils.CROPS.WINTER_RYE
                    ],
                    productRecommendationsFungicide: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY
                    ],
                    productRecommendationsPGR: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY
                    ],
                    nutrition: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.SUGAR_BEET,
                        CropUtils.CROPS.POTATO,
                        CropUtils.CROPS.OILSEED_RAPE,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.CANOLA,
                        CropUtils.CROPS.CORN,
                        CropUtils.CROPS.SOY
                    ],
                    pgr: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.WINTER_RYE
                    ],
                    dmc: [
                        CropUtils.CROPS.CORN
                    ],
                    healthyFields: [
                        CropUtils.CROPS.WINTER_WHEAT,
                    ]
                };
            case CountryUtils.COUNTRY.FRANCE:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE,
                        CropUtils.CROPS.DURUM_WHEAT
                    ],
                    zoneSprayFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY
                    ],
                    pgr: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY
                    ],
                    healthyFields: [
                        CropUtils.CROPS.WINTER_WHEAT,
                    ],
                    soilProperties: [
                        CountryUtils.SOIL_PROPERTIES.SOIL_PROPERTIES_TEXTURE,
                        CountryUtils.SOIL_PROPERTIES.SOIL_PROPERTIES_TAXONOMY
                    ]
                };
            case CountryUtils.COUNTRY.POLAND:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE,
                        CropUtils.CROPS.POTATO,
                        CropUtils.CROPS.SUGAR_BEET
                    ],
                    zoneSprayFeature: []
                };
            case CountryUtils.COUNTRY.UKRAINE:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE,
                        CropUtils.CROPS.POTATO,
                        CropUtils.CROPS.SUGAR_BEET,
                        CropUtils.CROPS.SPRING_WHEAT
                    ],
                    zoneSprayFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY
                    ],
                    productRecommendationsFungicide: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY
                    ]
                };
            case CountryUtils.COUNTRY.AUSTRIA:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE,
                        CropUtils.CROPS.POTATO,
                        CropUtils.CROPS.SUGAR_BEET
                    ],
                    zoneSprayFeature: []
                };
            case CountryUtils.COUNTRY.NETHERLAND:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.POTATO,
                        CropUtils.CROPS.SUGAR_BEET
                    ],
                    zoneSprayFeature: []
                };
            case CountryUtils.COUNTRY.CANADA:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT
                    ],
                    zoneSprayFeature: [
                        CropUtils.CROPS.CANOLA,
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.SPRING_WHEAT
                    ]
                };
            case CountryUtils.COUNTRY.USA:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.CORN
                    ],
                    zoneSprayFeature: [
                        CropUtils.CROPS.CANOLA,
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.SPRING_WHEAT
                    ],
                    soilProperties: [
                        CountryUtils.SOIL_PROPERTIES.SOIL_PROPERTIES_TEXTURE
                    ]
                };
            case CountryUtils.COUNTRY.BRAZIL:

                return {
                    sprayTimingFeature: [],
                    zoneSprayFeature: [
                        CropUtils.CROPS.SOYBEAN
                    ]
                };
            case CountryUtils.COUNTRY.ARGENTINA:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT
                    ],
                    zoneSprayFeature: [
                        CropUtils.CROPS.CORN,
                        CropUtils.CROPS.SOYBEAN
                    ]
                };
            case CountryUtils.COUNTRY.GREAT_BRITAIN:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE
                    ],
                    zoneSprayFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE
                    ]
                };
            case CountryUtils.COUNTRY.HUNGARY:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE
                    ],
                    zoneSprayFeature: []
                };
            case CountryUtils.COUNTRY.CZECH_REPUBLIC:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY,
                        CropUtils.CROPS.OILSEED_RAPE
                    ],
                    zoneSprayFeature: []
                };
            case CountryUtils.COUNTRY.BELGIUM:

                return {
                    sprayTimingFeature: [
                        CropUtils.CROPS.WINTER_WHEAT,
                        CropUtils.CROPS.WINTER_BARLEY
                    ],
                    zoneSprayFeature: []
                };
            case CountryUtils.COUNTRY.RUSSIA:
                return {

                };
            case CountryUtils.COUNTRY.ITALY:
                return {

                };
            case CountryUtils.COUNTRY.LITHUANIA:
                return {

                };
            case CountryUtils.COUNTRY.JAPAN:
                return {

                };
            case CountryUtils.COUNTRY.IRELAND:
                return {

                };
        }
    }

    static get SOIL_PROPERTIES () {

        return {
            SOIL_PROPERTIES_TEXTURE: 'SOIL_PROPERTIES_TEXTURE',
            SOIL_PROPERTIES_TAXONOMY: 'SOIL_PROPERTIES_TAXONOMY'
        };
    }

    static get SOIL_PROPERTY_FIELD_PROPERTY () {

        return {
            SOIL_PROPERTIES_TEXTURE: 'soilTextureUuid',
            SOIL_PROPERTIES_TAXONOMY: 'soilTaxonomyUuid'
        };
    }

    static isNA (country) {

        if (country === this.COUNTRY.CANADA ||
            country === this.COUNTRY.USA) {

            return true;
        } else {
            return false;
        }
    }

    static getNutritionValidity() {

        return '2020-12-31T00:00:00Z';
    }
}



// WEBPACK FOOTER //
// ./shared/utils/CountryUtils.js